// extracted by mini-css-extract-plugin
module.exports = {"item":"_02712f2b3b--item--QIbZZ","label":"_02712f2b3b--label--Fkglz","rating":"_02712f2b3b--rating--mePOG"};